import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Routes from '@/Routes';

const App = () => {

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Routes />
  );
}

export default App;